module.exports = __webpack_public_path__ + "img/pptx.e2b216ab.svg";